import { useContext, useState, useDeferredValue, useEffect, useMemo } from 'react';
import { SuggestionTypes } from '../Suggestions/types.esm.js';
import { getSearchHistory } from '../searchHistory.esm.js';
import { MAX_HISTORY_ITEMS, MAX_SUGGESTIONS_MAP } from '../constants.esm.js';
import RestClient, { isWordSearch, isEntity } from '@agoras/rest-client';
import { useQuery } from '@tanstack/react-query';
import logger from '@agoras/logger';
import { useLocale } from '../../../hooks/useLocale.esm.js';
import { useMarket } from '../../../hooks/useMarket.esm.js';
import { AppContext } from '../../context/context.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var isSuggestionsAPIResponse = function(response) {
    return typeof response !== 'undefined' && 'value' in response && 'totalCount' in response && 'suggestionsRequestId' in response;
};
var isPartnersAutocompleteResponse = function(response) {
    return typeof response !== 'undefined' && 'suggestions' in response;
};
var useSearchHistory = function(param) {
    var searchTerm = param.searchTerm;
    var maxItems = !searchTerm.length ? MAX_HISTORY_ITEMS : MAX_SUGGESTIONS_MAP.History;
    var termsHistory = getSearchHistory();
    return useMemo(function() {
        return termsHistory.filter(function(item) {
            if (typeof searchTerm === 'string') {
                return item.displayText.toLowerCase().includes(searchTerm);
            }
            return false;
        }).slice(0, maxItems);
    }, [
        searchTerm,
        termsHistory,
        maxItems
    ]);
};
var mapLinkedAddIns = function(linkedAddInsTypes) {
    var linkedInEntries = Object.entries(linkedAddInsTypes !== null && linkedAddInsTypes !== void 0 ? linkedAddInsTypes : {});
    if (!linkedInEntries.length) {
        return;
    }
    var addInTypes = linkedInEntries.reduce(function() {
        var acc = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref = _sliced_to_array(arguments.length > 1 ? arguments[1] : void 0, 2), key = _ref[0], value = _ref[1];
        if (typeof key !== 'string' || typeof value !== 'string') {
            return acc;
        }
        acc["".concat(key)] = value.split(',').map(function(product) {
            return product.trim();
        });
        return acc;
    }, {});
    return addInTypes;
};
var reduceSuggestionItems = function(deferredSuggestions) {
    if (!deferredSuggestions || !deferredSuggestions.value) {
        return [
            [],
            []
        ];
    }
    var value = deferredSuggestions.value;
    return value.reduce(function(acc, item) {
        var shouldAppendAutocomplete = acc[0].length < MAX_SUGGESTIONS_MAP.WordSearch;
        var shouldAppendOffer = acc[1].length < MAX_SUGGESTIONS_MAP.Entity;
        if (!shouldAppendAutocomplete && !shouldAppendOffer) {
            return acc;
        }
        var id = item.id, iconUrl = item.iconUrl, displayText = item.displayText, linkedAddInsTypes = item.linkedAddInsTypes, productType = item.productType;
        if (shouldAppendAutocomplete && isWordSearch(item)) {
            acc[0].push({
                id: "WordSearch:".concat(displayText),
                suggestionType: SuggestionTypes.WordSearch,
                displayText: displayText
            });
        } else if (shouldAppendOffer && isEntity(item)) {
            var suggestionEntity = {
                id: id,
                suggestionType: SuggestionTypes.Entity,
                displayText: displayText,
                iconUrl: iconUrl,
                linkedAddInsTypes: mapLinkedAddIns(linkedAddInsTypes),
                productType: productType
            };
            acc[1].push(suggestionEntity);
        }
        return acc;
    }, [
        [],
        []
    ]);
};
var USE_SUGGESTIONS_QUERY_KEY = 'react-query-search-suggestions';
var USE_SUGGESTIONS_DEBOUNCE_VALUE = 350;
var useSuggestions = function(param) {
    var searchTerm = param.searchTerm, gallery = param.gallery, mfeContext = param.mfeContext;
    var unifiedExperience = useContext(AppContext).unifiedExperience;
    var _useState = _sliced_to_array(useState(false), 2), shouldFireRequest = _useState[0], setShouldFireRequest = _useState[1];
    var searchHistory = useSearchHistory({
        searchTerm: searchTerm
    });
    var locale = useLocale().locale;
    var market = useMarket().market;
    var query = useQuery({
        queryKey: [
            USE_SUGGESTIONS_QUERY_KEY,
            {
                searchTerm: searchTerm,
                gallery: gallery
            }
        ],
        queryFn: /*#__PURE__*/ _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                if (!searchTerm.length) {
                    return [
                        2
                    ];
                }
                if (gallery === 'Partners') {
                    return [
                        2,
                        RestClient.Partners.getAutocomplete({
                            searchTerm: searchTerm,
                            locale: locale.locale
                        })
                    ];
                }
                return [
                    2,
                    RestClient.Search.getSuggestions({
                        searchTerm: searchTerm,
                        gallery: gallery !== null && gallery !== void 0 ? gallery : '',
                        language: locale.language,
                        market: market.countryCode,
                        unifiedExperience: unifiedExperience
                    })
                ];
            });
        }),
        enabled: shouldFireRequest,
        onSuccess: function(data) {
            if (!isSuggestionsAPIResponse(data)) {
                return;
            }
            logger.info(JSON.stringify(_object_spread({
                searchTerm: searchTerm
            }, data)), _object_spread({
                action: 'Search',
                actionModifier: 'Suggestions'
            }, mfeContext));
        },
        onSettled: function() {
            return setShouldFireRequest(false);
        }
    });
    var deferredSuggestions = useDeferredValue(query.data);
    useEffect(function() {
        if (!searchTerm.length) {
            return;
        }
        var timeout = setTimeout(function() {
            setShouldFireRequest(true);
        }, USE_SUGGESTIONS_DEBOUNCE_VALUE);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        searchTerm,
        gallery
    ]);
    return useMemo(function() {
        var suggestions = _to_consumable_array(searchHistory);
        if (isSuggestionsAPIResponse(deferredSuggestions)) {
            var _suggestions;
            var _reduceSuggestionItems = _sliced_to_array(reduceSuggestionItems(deferredSuggestions), 2), words = _reduceSuggestionItems[0], offers = _reduceSuggestionItems[1];
            (_suggestions = suggestions).push.apply(_suggestions, _to_consumable_array(words).concat(_to_consumable_array(offers)));
            return {
                suggestions: suggestions,
                suggestionsRequestId: deferredSuggestions.suggestionsRequestId
            };
        }
        if (isPartnersAutocompleteResponse(deferredSuggestions)) {
            var _suggestions1;
            var items = deferredSuggestions.suggestions.map(function(item) {
                return {
                    id: item.val,
                    suggestionType: SuggestionTypes.Partner,
                    displayText: item.text,
                    productType: item.type.toString()
                };
            });
            (_suggestions1 = suggestions).push.apply(_suggestions1, _to_consumable_array(items));
        }
        return {
            suggestions: suggestions
        };
    }, [
        deferredSuggestions,
        searchHistory
    ]);
};

export { useSearchHistory, useSuggestions };
